import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgSrc } from "@/lib/api";

export const PersonPhotos = ({ personId, name }) => {
  const [photos, setPhotos] = useState([]);
  useEffect(() => { api.get("/album", { params: { person_id: personId } }).then(({ data }) => setPhotos(data)); }, [personId]);
  if (photos.length === 0) return null;
  return (
    <section className="space-y-4" data-testid="person-photos">
      <h2 className="font-serif text-2xl font-semibold">Old pictures of {name}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {photos.map((ph) => (
          <Link key={ph.photo_id} to="/album" className="group block" data-testid={`person-photo-${ph.photo_id}`}>
            <img src={imgSrc(ph.url)} alt={ph.caption} className="w-full aspect-square object-cover rounded-2xl border border-[#E5DEC9] transition-transform duration-300 group-hover:-translate-y-1" />
            {(ph.caption || ph.year) && <p className="mt-1.5 text-xs text-[#52635B] truncate">{ph.caption} {ph.year && `· ${ph.year}`}</p>}
          </Link>
        ))}
      </div>
    </section>
  );
};
